import React from "react";
import i18n from "i18next";
import { Handle, Position } from "@xyflow/react";

/* eslint-disable react/prop-types */

export default function SceneNode({ data, selected }) {
  const { title, elementCount, isStart, bgColor } = data || {};

  return (
    <div
      style={{
        width: 200,
        minHeight: 80,
        borderRadius: 10,
        background: "#ffffff",
        border: `2px solid ${selected ? "#a963f5" : isStart ? "#16a34a" : "#e2e8f0"}`,
        boxShadow: selected
          ? "0 0 0 3px rgba(169,99,245,0.25), 0 4px 14px rgba(0,0,0,0.1)"
          : "0 2px 8px rgba(0,0,0,0.08)",
        padding: "10px 12px",
        display: "flex",
        flexDirection: "column",
        gap: 4,
        fontFamily: "system-ui, sans-serif",
        fontSize: 12,
        cursor: "pointer",
        transition: "border-color 0.15s, box-shadow 0.15s",
        position: "relative",
      }}
    >
      {/* Color dot + start badge */}
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <div
          style={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            background: bgColor || "#1a1a2e",
            border: "1.5px solid rgba(0,0,0,0.15)",
            flexShrink: 0,
          }}
        />
        {isStart && (
          <span
            style={{
              fontSize: 9,
              fontWeight: 700,
              color: "#16a34a",
              background: "rgba(22,163,74,0.1)",
              padding: "1px 5px",
              borderRadius: 4,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            {i18n.t("Start") || "▶ Başlangıç"}
          </span>
        )}
      </div>

      {/* Scene title */}
      <div
        style={{
          fontWeight: 600,
          color: "#1e293b",
          fontSize: 13,
          lineHeight: 1.3,
          wordBreak: "break-word",
        }}
      >
        {title || "Sahne"}
      </div>

      {/* Element count */}
      <div style={{ fontSize: 11, color: "#94a3b8" }}>{elementCount ?? 0} element</div>

      {/* React Flow handles */}
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: "#a963f5", width: 8, height: 8 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: "#a963f5", width: 8, height: 8 }}
      />
    </div>
  );
}
